import Link from '@/_application/core/components/ui/link';
import {LogoutIcon} from '@/_application/icons/logout';
import {ShoppingBagIcon} from '@/_application/icons/shopping-bag-icon';
import {UserAvatarIcon} from '@/_application/icons/user-avatar';
import {UserIcon} from '@/_application/icons/user-icon';
import {CustomerRoutes, Routes} from '@/config/routes';
import {Menu, Transition} from '@headlessui/react';
import {signOut} from 'next-auth/react';
import {Fragment, useEffect, useState} from 'react';
import {useLogout} from '@/_application/modules/auth/model/use-logout';
import {useUser} from '@/framework/user';
import { Button, Text } from '@kidslabs/mario-nextjs-react-ui-core';
import { getOrdersRoute } from '@/_application/modules/orders/utils/route';

export function UserAvatar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const {doLogout} = useLogout();
    const {me} = useUser();
    const logout = () => {
        signOut({redirect: false})
            .then(() => {
                doLogout();
            })
            .catch(() => {
                doLogout(); // Do logout even if signOut failed
            });
    };

    //window events to close menu on scroll and on click outside
    useEffect(() => {
        const onScroll = () => {
            setIsMenuOpen(false);
        };
        window.addEventListener('scroll', onScroll);

        const onClickout = () => {
            setIsMenuOpen(false);
        };
        globalThis.addEventListener('click', onClickout);

        return () => {
            window.removeEventListener('scroll', onScroll);
            globalThis.removeEventListener('click', onClickout);
        };
    }, []);

    const onToggleMenu = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        e.preventDefault();
        setIsMenuOpen(isOpen => !isOpen);
    };

    return (
        <Menu as="div">
            <Menu.Button as="div" onClick={onToggleMenu}>
                <div
                    className={`relative flex cursor-pointer items-center justify-between rounded-l-2xl py-3 pl-2.5 pr-1.5 text-[12px]`}
                    style={{background: isMenuOpen ? '#21409A' : '#ffffff', color: isMenuOpen ? '#ffffff' : '#434657'}}>
                    <div className="flex items-center justify-center">
                        <UserAvatarIcon className="h-8.5 w-8.5 shrink-0" />

                        <div className="ml-1">
                            <p>Xin chào, </p>
                            <p className="line-clamp-1 font-bold">{me?.info?.lastname ?? 'Bạn'}</p>
                        </div>
                    </div>
                </div>
            </Menu.Button>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
                show={isMenuOpen}>
                <Menu.Items className="absolute bottom-[-170%] left-0 z-50 origin-bottom-left divide-y divide-gray-100 rounded-[10px] bg-[#21409A] p-4 pr-8 text-xs text-white shadow-lg ring-1 ring-black/5 after:absolute after:top-[-7px] after:border-x-8 after:border-b-8 after:border-t-0 after:border-solid after:border-x-transparent after:border-b-primary focus:outline-none">
                    <Menu.Item>
                        <div className="flex flex-col gap-2.5">
                            <Link
                                href={`${Routes.customer}/${CustomerRoutes.info}`}
                                className="flex items-center gap-2 transition-opacity hover:opacity-80">
                                <UserIcon className="h-3 w-3" />
                                Thông tin tài khoản
                            </Link>
                            <Link
                                href={getOrdersRoute()}
                                className="flex items-center gap-2 transition-opacity hover:opacity-80">
                                <ShoppingBagIcon className="h-3 w-3" />
                                Quản lý đơn hàng
                            </Link>
                            <Button
                                onClick={logout}
                                aria-label="Đăng xuất"
                                className="p-0! transition-opacity shadow-none! h-auto! hover:opacity-80! hover:bg-transparent!"
                                contentClassName='w-full flex items-center gap-1'
                            >
                                <LogoutIcon className="h-4 w-4" />
                                <Text className='text-2sm'>Đăng xuất</Text>
                            </Button>
                        </div>
                    </Menu.Item>
                </Menu.Items>
            </Transition>
        </Menu>
    );
}
